export enum RaceTypeEnum {
    SOLO = 'solo',
    TEAM = 'team',
    RELAY = 'relay',
}
